<template>
  <div class="col-span-12 lg:col-span-8 xxl:col-span-9">
    <div class="intro-y flex items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">Event Configuration</h2>
    </div>
    <div class="mt-5">
      <!-- BEGIN: Event Config Content -->
      <div class="config-content">
        <form class="validate-form" @submit.prevent="saveEventSettings">
          <div class="grid grid-cols-12 gap-6">
            <div class="col-span-12">
              <div class="intro-y box mt-2 p-6">
                <EventSettings
                  v-if="eventSettings && eventSettings.event5kSettings"
                  v-model:eventName="eventSettings.appTitle"
                  v-model:eventState="eventSettings.appState"
                  v-model:eventFundraisingGoal="
                    eventSettings.eventFundraisingGoal
                  "
                  v-model:eventYear="eventSettings.appYear"
                  v-model:reportingWindows="eventSettings.reportingWindows"
                  v-model:starOfTheTeamLimit="eventSettings.starOfTheTeamLimit"
                  v-model:teamDonationLimit="eventSettings.donationMinimum"
                  v-model:offerScholarship="eventSettings.offerScholarship"
                  v-model:eventTerms="eventSettings.termsAndConditionsUrl"
                  v-model:publicEventSite="eventSettings.publicEventSite"
                  :event-name="eventSettings.appTitle"
                  :event-state="eventSettings.appState"
                  :event-fundraising-goal="eventSettings.eventFundraisingGoal"
                  :event-year="eventSettings.appYear"
                  :star-of-the-team-limit="eventSettings.starOfTheTeamLimit"
                  :team-donation-limit="eventSettings.donationMinimum"
                  :offer-scholarship="eventSettings.offerScholarship"
                  :event-terms="eventSettings.termsAndConditionsUrl"
                  :public-event-site="eventSettings.publicEventSite"
                />
                <div class="flex justify-end mt-8">
                  <button type="submit" class="btn btn-primary w-20 mr-auto">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <TeamReset />
      </div>
      <!-- END: Event Config Content -->
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useVuelidate } from "@vuelidate/core";
import { useStore } from "@/store";
import { updateEventSettings } from "@/api/event-settings";
import EventSettings from "@/components/form-inputs/EventSettings";
import TeamReset from "./TeamReset.vue";

export default defineComponent({
  components: {
    EventSettings,
    TeamReset
  },
  setup() {
    const validate = useVuelidate();
    const store = useStore();
    const eventSettings = computed(() => store.getters["main/eventSettings"]);

    const sendNotification = async response => {
      let note = {
        show: true,
        title: "Success",
        message: "Event settings have been updated."
      };
      if (response.code) {
        note = {
          show: true,
          error: true,
          title: "Error",
          message: "There was a problem updating the event settings."
        };
      }
      await store.dispatch("notifications/displayNotification", note);
    };

    const saveEventSettings = async () => {
      validate.value.$touch();
      if (validate.value.$invalid) {
        let response = {
          code: 400
        };
        await sendNotification(response);
      } else {
        const saveEventSettingsResult = await updateEventSettings(
          eventSettings.value
        );
        await sendNotification(saveEventSettingsResult);
      }
    };

    return {
      eventSettings,
      saveEventSettings
    };
  }
});
</script>
